import { useTranslation } from 'react-i18next';
import SingleValueTile from '../tiles/SingleValueTile/SingleValueTile';
import ReportingDashboardSection, {
    SectionItem,
    SectionProps,
} from './ReportingDashboardSection';
import {
    formatElapsedMilliseconds,
    formatRating,
} from '../../../../../utils/formatters';
import { useSelector } from '../../../../../store/hooks';
import { GridItemSpans } from '../../../../../controls/ResponsiveGrid/ResponsiveGridItem';

const itemSpans: GridItemSpans = {
    tabletSpan: 6,
    desktopSpan: 4,
    wideSpan: 3,
} as const;

const PerformanceSection: React.FC<SectionProps> = ({ className }) => {
    const { t } = useTranslation();

    const { previousRange, currentRange } = useSelector(
        (x) => x.reportingDashboard
    );

    return previousRange && currentRange ? (
        <ReportingDashboardSection className={className}>
            <>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_AvgResponseTime')}
                        previousValue={
                            previousRange.performance
                                .averageResponseMilliseconds
                        }
                        currentValue={
                            currentRange.performance.averageResponseMilliseconds
                        }
                        formatter={formatElapsedMilliseconds}
                        reverseTrend
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_AvgHandlingTime')}
                        previousValue={
                            previousRange.performance
                                .averageHandlingMilliseconds
                        }
                        currentValue={
                            currentRange.performance.averageHandlingMilliseconds
                        }
                        formatter={formatElapsedMilliseconds}
                        reverseTrend
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_AvgFlightTeamRating')}
                        previousValue={
                            previousRange.ratings.averageFlightTeamRating
                        }
                        currentValue={
                            currentRange.ratings.averageFlightTeamRating
                        }
                        formatter={formatRating}
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_AvgGroundTeamRating')}
                        previousValue={
                            previousRange.ratings.averageGroundTeamRating
                        }
                        currentValue={
                            currentRange.ratings.averageGroundTeamRating
                        }
                        formatter={formatRating}
                    />
                </SectionItem>
            </>
        </ReportingDashboardSection>
    ) : null;
};

export default PerformanceSection;
